import fetch from 'isomorphic-fetch';

import { noticeError } from '../newrelic';

import config from '../config';
import {
    NON_GUEST_ENTITLEMENTS,
    RPS_ENTITLEMENT,
    II_ENTITLEMENT
} from '../utils/constants';

const authFrag = 'v0/ciam-public/me';

const checkAuthStatus = async () => {
    const res = await fetch(
        `${config('apiDomain', 'https://apidev.awstrp.net')}/${authFrag}`,
        {
            method: 'get',
            credentials: 'include',
            headers: {
                apikey: config('apiKey'),
                'Content-Type': 'application/json',
                'X-TRP-Requested-With': 'XMLHttpRequest'
            }
        }
    );
    return res;
};

/**
 * @return {Boolean} - indicates if authenticated
 */
export const tokenExchange = async () => {
    try {
        const authResponse = await checkAuthStatus();
        const authenticated = authResponse.ok;

        return authenticated;
    } catch (err) {
        const msg = 'an error occured during token exchange';
        noticeError(err, { msg });
        return false;
    }
};

/**
 * @return {Boolean} - indicates if using a guest account login
 */
export const checkUserAccountType = async () => {
    const authResponse = await checkAuthStatus();

    return authResponse
        .json()
        .then(({ entitlements }) => {
            const isGuestAccount = !entitlements.some((entitlement) =>
                NON_GUEST_ENTITLEMENTS.includes(entitlement)
            );
            const isRpsUser = entitlements.includes(RPS_ENTITLEMENT);
            const isCrossoverUser =
                entitlements.includes(RPS_ENTITLEMENT) &&
                entitlements.includes(II_ENTITLEMENT);

            return { isGuestAccount, isRpsUser, isCrossoverUser };
        })
        .catch((error) => {
            throw new Error(
                `Should not be checking entitlements if not logged in!:\n${error}`
            );
        });
};



// WEBPACK FOOTER //
// ./src/token-exchange/authentication.js